
















































































































































import { Component, Prop, Vue } from "vue-property-decorator";

import { CookieHelper } from "@/helper/cookieHelper";
import { DebugHelper } from "@/helper/debugHelper";
import platform from '@/helper/platform';

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";
import QuestionaireBackAlertModal from "@/commonComponents/alertModal/questionaireBackAlertModal/questionaireBackAlertModal.vue";

import Close from "../resources/close.vue";
import RadioOn from "../resources/radioOn.vue";
import ArrowDown from "../resources/arrowDown.vue";


@Component({
  components: {
      Close,
      RadioOn,
      ArrowDown,
      DropdownList,
      QuestionaireBackAlertModal
  }
})

export default class SignUp extends Vue {

    sexId = 1;
    birthYear = "選択してください";
    prefectures = "選択してください";
    prefecturesId = 0;
    useId = 1;
    industry = "選択してください";
    industryId = 0;
    jobCategory = "選択してください";
    jobCategoryId = 0;
    needsRecommend = 1;

    private readonly MIN_YEAR = 1900;

    isBirthYearDropdownActive = false;
    isPrefecturesDropdownActive = false;
    isIndustryDropdownActive = false;
    isJobCategoryDropdownActive = false;
    isQuestionaireBackAlertModal = false;

    private onDoCommand(command : string, param : any){
        this.$emit("doCommand", command, param);
    }

    // 性別
    private selectSexId(select){
        this.sexId = select;
    }

    // 生まれ年
    private get birthYearText(){
        return this.birthYear;
    }

    private get birthYearDropdownItems() {
        var items = new Array();
        var date = new Date();

        for(var year = date.getFullYear(); year >= this.MIN_YEAR; year--){
                items.push({
                id: year,
                label: year + "年",
                isSelected: this.birthYear == year + "年"
            });
        }
        return items;
    }

    private setBirthYear(year, id){
        this.birthYear = year + "年";
        this.isBirthYearDropdownActive = false;
    }

    // 都道府県
    private get prefecturesText(){
        return this.prefectures;
    }

    private get prefecturesDropdownItems() {
        var items = new Array();

        for(var i = 0; i < 47; i++){
                items.push({
                id: i,
                label: this.prefecturesList[i],
                isSelected: this.prefectures == this.prefecturesList[i]
            });
        }
        return items;
    }

    private get prefecturesList(){
        return [
            "北海道",
            "青森県",
            "岩手県",
            "宮城県",
            "秋田県",
            "山形県",
            "福島県",
            "茨城県",
            "栃木県",
            "群馬県",
            "埼玉県",
            "千葉県",
            "東京都",
            "神奈川県",
            "新潟県",
            "富山県",
            "石川県",
            "福井県",
            "山梨県",
            "長野県",
            "岐阜県",
            "静岡県",
            "愛知県",
            "三重県",
            "滋賀県",
            "京都府",
            "大阪府",
            "兵庫県",
            "奈良県",
            "和歌山県",
            "鳥取県",
            "島根県",
            "岡山県",
            "広島県",
            "山口県",
            "徳島県",
            "香川県",
            "愛媛県",
            "高知県",
            "福岡県",
            "佐賀県",
            "長崎県",
            "熊本県",
            "大分県",
            "宮崎県",
            "鹿児島県",
            "沖縄県"
        ]
    }

    private setPrefectures(prefecturesId){
        this.isPrefecturesDropdownActive = false;
        this.prefectures = this.prefecturesList[prefecturesId];
        this.prefecturesId = prefecturesId + 1;
    }

    // 利用用途
    private selectUseId(select){
        this.useId = select;
    }

    selectNeedsRecommend(needs) {
        this.needsRecommend = needs;
    }

    // 業種
    private get industryText(){
        return this.industry;
    }

    private get industryDropdownItems() {
        var items = new Array();

        for(var i = 0; i < this.industryList.length; i++){
                items.push({
                id: i,
                label: this.industryList[i],
                isSelected: this.industry == this.industryList[i]
            });
        }
        return items;
    }

    private get industryList(){
        return [
            "農林業",
            "漁業",
            "鉱業",
            "建設業",
            "製造業",
            "電気・ガス・水道業",
            "情報通信業",
            "運輸業、郵便業",
            "卸売業、小売業",
            "金融業、保険業",
            "不動産業・物品賃貸業",
            "学術研究、専門・技術サービス業",
            "宿泊業、飲食サービス業",
            "生活関連サービス業、娯楽業",
            "教育、学習支援業",
            "医療、福祉",
            "複合サービス事業",
            "その他サービス業",
            "公務",
            "主婦",
            "学生",
            "働いていない",
            "その他の業種"
        ]
    }

    private setIndustry(industryId){
        // if(this.industry != industry){
        //     this.jobCategory = "選択してください";
        // }
        this.isIndustryDropdownActive = false;
        this.industry = this.industryList[industryId];
        this.industryId = industryId + 1;
    }

    // 職種
    private get jobCategoryText(){
        return this.jobCategory;
    }

    private jobCategoryDropdownItems() {
        var items = new Array();

        for(var i = 0; i < this.jobCategoryList.length; i++){
                items.push({
                id: i,
                label: this.jobCategoryList[i],
                isSelected: this.jobCategory == this.jobCategoryList[i]
            });
        }
        return items;
    }

    private get jobCategoryList(){
        return [
            "経営・自営",
            "管理職",
            "営業職",
            "商品販売職",
            "専門・技術職",
            "企画・マーケティング職",
            "営業・企画事務職",
            "総務・人事事務職",
            "会計事務職",
            "生産事務職",
            "サービス職",
            "保安職",
            "農林漁業職",
            "生産工程職",
            "輸送・機械運転職",
            "建設・採掘職",
            "運搬・清掃職",
            "働いていない",
            "その他の職種"
        ]
    }

    private setJobCategory(jobCategoryId){
        this.isJobCategoryDropdownActive = false;
        this.jobCategory = this.jobCategoryList[jobCategoryId];
        this.jobCategoryId = jobCategoryId + 1;
    }

    private jobCategoryDropdown(){
        if(this.industry == "選択してください"){ return; }

        this.isJobCategoryDropdownActive = true;
    }

    // ボタン
    private returnPage(){
        this.onDoCommand("returnPage", null);
    }

    private onOk(){
        var param = {
            installId: CookieHelper.getItem("installId"),
            certificationToken: CookieHelper.getItem("certificationToken"),
            platformId: String(platform.id),
            genderId: this.sexId,
            birthdayYear: this.birthYearText.slice(0, -1),
            prefectureId: this.prefecturesId,
            usePatternId: this.useId,
            businessCategoryId: this.industryId,
            jobCategoryId: this.jobCategoryId,
            needsRecommend: this.needsRecommend
        }
        DebugHelper.trace(param);
        this.onDoCommand("questionnaire", param);
    }

    // css関連
    private getCursor(item, onMouseChoise){
        var cursor = "";
        if(item == "sex"){
            cursor = this.sexId == onMouseChoise ? "default" : "pointer";
        }
        else if(item == "useId"){
            cursor = this.useId == onMouseChoise ? "default" : "pointer";
        }
        else if(item == "recommend"){
            cursor = this.needsRecommend == onMouseChoise ? "default" : "pointer";
        }
        return {cursor : cursor};
    }

    private get isCanClick(){
        var initialValue = "選択してください";
        return this.birthYear != initialValue && this.prefectures != initialValue && this.industry != initialValue && this.jobCategory != initialValue;
    }

    private get pointerStyle(){
        var cursor = this.industry == "選択してください" ? "default" : "pointer";
        return { cursor : cursor };
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBorderColor(){
        var style = {
            border : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigBorderBottomColor(){
        var style = {
            borderBottom : "solid 1px " + this.userConfigColor
        };
        return style;
    }
    private get userConfigButtonColor(){
        var style = {
            background : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private userConfigTextAColorOpacityStyle(text){
        var style;
        if(text == "選択してください"){
            style = {
                color : this.userConfigTextAColorStyle.color,
                opacity : 0.5
            }
        }else{
            style = this.userConfigTextAColorStyle;
        }
        return style;
    }
}
